import React from 'react';
import { notification } from 'antd';
import PropTypes from 'prop-types';

const RDNotification = ({ type, message, description, duration, placement, notificationStyle }) => {
  notification[type]({
    message,
    description,
    duration,
    placement,
    style: notificationStyle,
  });
  return <div />;
};

RDNotification.defaultProps = {
  type: 'success',
  message: '',
  description: '',
  duration: 4.5,
  placement: 'topRight',
  notificationStyle: {},
};

RDNotification.propTypes = {
  /** Type of Notification, Can be set to - open | success | info | warning | error */
  type: PropTypes.string,
  /** The title of notification box */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** The content of notification box */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Time in seconds before Notification is closed. When set to 0 or null, it will never be closed automatically */
  duration: PropTypes.number,
  /** Position of Notification, can be one of - topLeft | topRight | bottomLeft | bottomRight */
  placement: PropTypes.string,
  /** Customized inline style */
  notificationStyle: PropTypes.shape({}),
};

export default RDNotification;
